import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import PageChanger from "../../Helpers/Components/Pagination"
import Handler from "../../Helpers/Components/Handler"
import moment from "moment";
import TablePlaceHolder from "../../Helpers/Components/TablePlaceHolder"
import DatePicker, { Calendar } from "react-multi-date-picker";
import { DropdownToggle, DropdownButton } from '../../Helpers/Components/Dropdown';
import { toast } from "react-toastify";
import Modal from "../../Helpers/Components/Modal";
import * as FileSaver from "file-saver";
import XLSX from 'sheetjs-style';
import { getCookie, reloadWindow } from "../../Helpers/Utils";
import Select from 'react-select'
import { clearValue } from "../../Reducer/bookingSlice";
import { useDispatch } from "react-redux";
import { useAuth } from "../../Contexts/AuthenticateProvider";
import BookingStats from "./BookingStats";

const List = () => {
    const { pageNo } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { userDetails } = useAuth()
    const [element, setElement] = useState()
    const [info, setInfo] = useState(false)
    const requestRef = useRef(0);
    const [next, setNext] = useState(false)
    const [cancel, setCancel] = useState({ booking: "", remarks: "" })
    const [loading, setLoading] = useState(false)
    const [cart, setCart] = useState(localStorage.getItem('filter'));
    const [bookingDetails, setBookingDetails] = useState([])
    const [total, setTotal] = useState(0)
    // const [subadminList, setSubadminList] = useState([])
    const [leadList, setLeadList] = useState([])
    const [checkDate, setCheckDate] = useState(cart ? JSON?.parse(cart)?.checkDate ? JSON?.parse(cart)?.checkDate : "" : "")
    const [picheckDate, setPicheckDate] = useState(cart ? JSON?.parse(cart)?.picheckDate ? JSON?.parse(cart)?.picheckDate : "" : "")
    // Registration ("New Bookings Today") and cancellation ("Cancelled Today")
    // date ranges — set by clicking the dashboard cards in BookingStats, and
    // persisted the same way as checkDate/picheckDate above.
    const [createdDate, setCreatedDate] = useState(cart ? JSON?.parse(cart)?.createdDate ? JSON?.parse(cart)?.createdDate : "" : "")
    const [cancelledDate, setCancelledDate] = useState(cart ? JSON?.parse(cart)?.cancelledDate ? JSON?.parse(cart)?.cancelledDate : "" : "")
    const person = getCookie('person')
    const [modal, showModal] = useState(false)
    const calendarRef = useRef();
    const [carDetails, setCarDetails] = useState([])
    const calendarRef1 = useRef();
    const [downloadModal, setDownloadModal] = useState(false)
    const [status, setStatus] = useState({ label: "Completed", value: "Completed" })
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsgeet.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const [billingDate, setBillingDate] = useState(new Date(new Date().setDate(1)))
    const [search, setSearch] = useState(cart ? JSON?.parse(cart)?.search ? JSON?.parse(cart)?.search : "" : "");
    const [appliedSearch, setAppliedSearch] = useState(cart ? JSON?.parse(cart)?.search || "" : "");
    const [filter, setFilter] = useState({
        count: cart ? JSON?.parse(cart)?.count ? JSON?.parse(cart)?.count : 10 : 10,
        sortBy: "deliveryDetails.delivery",
        sort: true,
        createdBy: cart ? JSON?.parse(cart)?.createdBy ? JSON?.parse(cart)?.createdBy : "All" : "All",
        deliveryBy: cart ? JSON?.parse(cart)?.deliveryBy ? JSON?.parse(cart)?.deliveryBy : "All" : "All",
        carId: cart ? JSON?.parse(cart)?.carId ? JSON?.parse(cart)?.carId : "All" : "All",
        remarks: cart ? JSON?.parse(cart)?.remarks ? JSON?.parse(cart)?.remarks : "All" : "All",
        pickupBy: cart ? JSON?.parse(cart)?.pickupBy ? JSON?.parse(cart)?.pickupBy : "All" : "All",
        status: cart ? JSON?.parse(cart)?.status ? JSON?.parse(cart)?.status : "All" : "All",
        type: cart ? JSON?.parse(cart)?.type ? JSON?.parse(cart)?.type : "All" : "All",
        leadMode: cart ? JSON?.parse(cart)?.leadMode ? JSON?.parse(cart)?.leadMode : { label: "All", value: "All" } : { label: "All", value: "All" },
        leadAttendedBy: cart ? JSON?.parse(cart)?.leadAttendedBy ? JSON?.parse(cart)?.leadAttendedBy : { label: "All", value: "All" } : { label: "All", value: "All" },
    })
    const handleSearch = () => {
        setPageNo(1);
        setItem('search', search)
        setAppliedSearch(search);
    };
    const handleKeyDown = (event) => { if (event.key === "Enter") { event.preventDefault(); handleSearch(); } };
    const handleOpen = () => {
        if (calendarRef.current) {
            calendarRef.current.openCalendar();
        }
    };
    const handleOpen1 = () => {
        if (calendarRef1.current) {
            calendarRef1.current.openCalendar();
        }
    };
    const sort = (sortBy, sort) => {
        setPageNo(1)
        setFilter((prev) => ({
            ...prev,
            sortBy: sortBy,
            sort: sort
        }))
        setItem('sortBy', sortBy)
        setItem('sort', sort)
    }
    const setPageNo = (value) => navigate(`/booking/${value}`)
    const getBookingDetails = async () => {
        const currentRequestId = ++requestRef.current;
        setLoading(true);
        let data = {};
        if (appliedSearch) data.search = appliedSearch
        if (filter?.leadMode?.label !== "All") data.leadMode = filter.leadMode.value;
        if (filter?.leadAttendedBy?.label !== "All") data.leadAttendedBy = filter.leadAttendedBy.value;
        if (filter?.carId !== "All") data.carId = filter.carId;
        if (checkDate?.length) {
            data.deliveryFrom = moment(checkDate[0]).format("DD-MM-YYYY");
            data.deliveryTo = moment(checkDate[1] || checkDate[0]).format("DD-MM-YYYY");
        }
        if (picheckDate?.length) {
            data.pickupFrom = moment(picheckDate[0]).format("DD-MM-YYYY");
            data.pickupTo = moment(picheckDate[1] || picheckDate[0]).format("DD-MM-YYYY");
        }
        if (createdDate?.length) {
            data.from = moment(createdDate[0]).format("DD-MM-YYYY");
            data.to = moment(createdDate[1] || createdDate[0]).format("DD-MM-YYYY");
        }
        if (cancelledDate?.length) {
            data.cancelledFrom = moment(cancelledDate[0]).format("DD-MM-YYYY");
            data.cancelledTo = moment(cancelledDate[1] || cancelledDate[0]).format("DD-MM-YYYY");
        }
        if (filter.deliveryBy !== "All") data.deliveryBy = filter.deliveryBy;
        if (filter.pickupBy !== "All") data.pickupBy = filter.pickupBy;
        if (filter.status !== "All") data.status = [filter.status];
        if (filter.remarks !== "All") data.remarks = filter.remarks;
        if (filter.billingDate) data.billingDate = filter.billingDate;
        const response = await Handler({
            method: "post",
            url: `/booking/${Object.keys(data)?.length > 0 ? "list" : "searching"}/${pageNo}?count=${filter?.count || 10}`,
            data: { ...data, sort: filter.sort, sortBy: filter.sortBy }
        });
        if (currentRequestId !== requestRef.current) return;
        if (response?.success) {
            setBookingDetails(response.data.current);
            setNext(response.data.next);
            setTotal(response.data.total);
        } else {
            setBookingDetails([]);
            setNext(false);
            setTotal(0);
        }
        setLoading(false);
    };
    const getLeadList = async () => {
        const response = await Handler({ method: "get", url: `/booking/lead-list`, })
        if (response?.success) {
            const lead = response?.data
            if (lead?.length) {
                const filteredLead = lead?.filter(element => element?.leadId !== userDetails?.id && element?.leadId !== userDetails?.adminId)
                const ourName = lead?.find(element => element?.leadId === userDetails?.id || element?.leadId === userDetails?.adminId)
                setLeadList([{ label: "All", value: "All" }, ...(ourName ? [{ label: ourName?.name?.toUpperCase(), value: ourName?.leadId }] : []), ...(filteredLead?.length ? filteredLead?.map((element) => { return { label: element?.name?.toUpperCase(), value: element?.leadId } }) : [])])
            } else {
                setLeadList([])
            }
        } else {
            setLeadList([])
        }
    }
    const setFilteration = (name, value) => {
        setPageNo(1)
        setFilter((prev) => ({ ...prev, [name]: value }))
        setItem(name, value)
    }
    const handleToggle = (element) => {
        setElement(element);
        setInfo(true)
    }
    const formatDate = (dateStr) => {
        const date = new Date(dateStr.replace(" ", "T"));
        const pad = (n) => n.toString().padStart(2, "0");
        let hours = date.getHours();
        const minutes = pad(date.getMinutes());
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(hours)}:${minutes} ${ampm}`;
    }
    const parseFormattedDate = (str) => {
        if (!str) return new Date(0);

        const [datePart, timePart, ampm] = str.split(" ");
        const [dd, mm, yyyy] = datePart.split("/").map(Number);
        let [hh, min] = timePart.split(":").map(Number);

        if (ampm === "PM" && hh !== 12) hh += 12;
        if (ampm === "AM" && hh === 12) hh = 0;

        return new Date(yyyy, mm - 1, dd, hh, min);
    };
    const exportToExcel = async () => {
        // if (!billingDate) {
        //     toast.error("Choose month")
        //     return
        // }
        const data = {
            ...(search ? { search: search } : {}),
            ...(checkDate?.length ? { deliveryFrom: moment(new Date(checkDate[0]))?.format("DD-MM-YYYY"), deliveryTo: checkDate?.length >= 2 ? moment(new Date(checkDate[1]))?.format("DD-MM-YYYY") : moment(new Date(checkDate[0]))?.format("DD-MM-YYYY") } : {}),
            ...(picheckDate?.length ? { pickupFrom: moment(new Date(picheckDate[0]))?.format("DD-MM-YYYY"), pickupTo: picheckDate?.length >= 2 ? moment(new Date(picheckDate[1]))?.format("DD-MM-YYYY") : moment(new Date(picheckDate[0]))?.format("DD-MM-YYYY") } : {}),
            ...(filter?.createdBy !== "All" ? { createdId: filter?.createdBy } : {}),
            ...(filter?.deliveryBy !== "All" ? { deliveryBy: filter?.deliveryBy } : {}),
            ...(filter?.pickupBy !== "All" ? { pickupBy: filter?.pickupBy } : {}),
            ...(filter?.carId !== "All" ? { carId: filter?.carId } : {}),
            ...(filter?.leadMode?.label !== "All" ? { leadMode: filter?.leadMode?.value } : {}),
            ...(filter?.leadAttendedBy?.label !== "All" ? { leadAttendedBy: filter?.leadAttendedBy?.value } : {}),
            ...(filter?.type !== "All" ? { type: filter?.type } : {}),
            // ...(status?.value !== "All" ? { status: [status?.value] } : {}),
            ...(filter?.remarks !== "All" ? { remarks: filter?.remarks } : {}),
            ...(filter?.status !== "All" ? { status: [filter?.status] } : {}),
            ...(filter?.billingDate ? { billingDate: filter?.billingDate } : {}),
            sort: filter?.sort,
            sortBy: filter?.sortBy,
            // billingDate
        }
        setLoading(true)
        const response = await Handler({ method: 'post', data, url: `/admin/download/booking` })
        if (response?.success) {
            setDownloadModal(false)
            setBillingDate(new Date(new Date().setDate(1)))
            if (!response?.data?.length) {
                toast.error("Data not found")
                return
            }
            const downloadData = response.data.map(ele => {
                return {
                    'VEHICLE': ele['VEHICLE'],
                    'STATUS': ele['STATUS'],
                    'FORM NO': ele['FORM NO'],
                    'CUS-ID': ele['CUS-ID'],
                    'CUSTOMER NAME': (ele['CUSTOMER NAME']?.toUpperCase() || ""),
                    'BTB': ele['BTB'] ? ele['BTB']?.toUpperCase() : "",
                    'SRC': ele['SRC'],
                    'OPEN DATE & TIME': ele['OPEN DATE & TIME'] ? formatDate(ele['OPEN DATE & TIME']) : "",
                    "DAYS": ele['DAYS'],
                    'CLOSED DATE & TIME': ele['CLOSED DATE & TIME'] ? formatDate(ele['CLOSED DATE & TIME']) : "",
                    'MOBILE 1': ele['MOBILE 1'],
                    'MOBILE 2': ele['MOBILE 2'],
                    'MOBILE 3': ele['MOBILE 3'],
                    'MSD RENT': ele['MSD RENT'],
                    'OFFER': ele['OFFER'],
                    'FINAL PRICE': ele['FINAL PRICE'],
                    'FREE KMS': ele['FREE KMS'],
                    'EXTRA PER KMS CHARGE': ele['SEGMENT'] === "SUV" ? 10 : 7,
                    'TOTAL RENT': ele['TOTAL RENT'],
                    'DEPOSIT': ele['DEPOSIT'],
                    'DELI CHARGE': ele['DELI CHARGE'],
                    'DELIVERY LOCATION': ele['DELIVERY LOCATION']?.toUpperCase(),
                    'DELIVERY DETAILS': ele['DELIVERY LOCATION']?.toLowerCase() === "po" ? "INSIDE" : "OUTSIDE",
                    'DELIVERY PERSON': ele['DELIVERY PERSON'] ? ele['DELIVERY PERSON']?.toUpperCase() : "",
                    'ADVANCE MODE': (ele['ADVANCE MODE'] || "") + "-" + (ele['ADVANCE AMT'] || ""),
                    'CASH': ele['ADVANCE MODE'] && ele['ADVANCE MODE']?.toLowerCase() === "cash" ? ele['ADVANCE AMT'] : 0,
                    'PPAY/GPAY': ele['ADVANCE MODE'] && ele['ADVANCE MODE']?.toLowerCase() === "upi" ? ele['ADVANCE AMT'] : 0,
                    'QR/SWIPE': ele['ADVANCE MODE'] && ele['ADVANCE MODE']?.toLowerCase() === "net banking" ? ele['ADVANCE AMT'] : 0,
                    'TRIP START AMT COLLECTED': ele['TRIP START AMT COLLECTED'],
                    'START KMS': ele['START KMS'],
                    'START FUEL': (ele['START FUEL'] || 0) + "%",
                    'END KMS': ele['END KMS'],
                    'END FUEL': (ele['END FUEL'] || 0) + "%",
                    "TOTAL RUNNED KMS": Number(ele['TOTAL RUNNED KMS'] || 0) <= 0 ? 0 : ele['TOTAL RUNNED KMS'],
                    'CONSUMED FUEL': (ele['CONSUMED FUEL'] || 0) + "%",
                    'EXTRA KMS': ele['EXTRA KMS'],
                    'EXTRA KMS CHARGE': ele['EXTRA KMS CHARGE'],
                    'NO OF LTRS': ele['NO OF LTRS'],
                    'EXTRA FUEL CHARGE': ele['EXTRA FUEL CHARGE'],
                    'EXTRA HRS': ele['EXTRA HRS'],
                    'EXTRA HRS CHARGES': ele['EXTRA HRS CHARGES'],
                    'PICKUP CHARGE': ele['PICKUP CHARGE'],
                    'PICKUP LOCATION': ele['PICKUP LOCATION']?.toUpperCase(),
                    'PICKUP DETAILS': ele['PICKUP LOCATION']?.toLowerCase() === "po" ? "INSIDE" : "OUTSIDE",
                    'PICKUP EXECUTIVE': ele['PICKUP EXECUTIVE'] ? ele['PICKUP EXECUTIVE']?.toUpperCase() : "",
                    'EXTENSION/CANCELL CHARGE': ele['EXTENSION/CANCELL CHARGE'],
                    'DAMAGE CHARGE': ele['DAMAGE CHARGE'],
                    'TRIP START COLLECTED AMT': ele['TRIP START AMT COLLECTED'],
                    'TOTAL AMT NEED TO COLLECT FROM CUSTOMER': ele['TOTAL AMT NEED TO COLLECT FROM CUSTOMER'],
                    'FASTTAG OPEN': ele['FASTTAG OPEN'],
                    'FASTTAG CLOSE': ele['FASTTAG CLOSE'],
                    'FASTTAG REFUND': ele['FASTTAG REFUND'],
                    'WAIVE OFF': ele['WAIVE OFF'],
                    'REFUND AMT': ele['REFUND'],
                    'COST TO COMPANY': ele['COST TO COMPANY'],
                    'REFUND MODE': ele['REFUND MODE'],
                    'REFUND DATE': ele['REFUND DATE'],
                    'PROOF COLLECTED': ele['PROOF']?.length ? ele['PROOF']?.toString() : "",
                    'DAMAGE DESC': ele['DAMAGE DESC'],
                    'REMARKS': ele['REMARKS']
                }
            })
            const sortedList = [...downloadData].sort((a, b) => {
                return parseFormattedDate(a['OPEN DATE & TIME'])
                    - parseFormattedDate(b['OPEN DATE & TIME']);
            })
            const ws = XLSX?.utils?.json_to_sheet(sortedList);
            const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, "Bookings" + fileExtension);
            setLoading(false)
        } else {
            setLoading(false)
            toast.error(response?.message)
        }
    }
    const cancelBooking = async () => {
        if (!cancel?.remarks) {
            toast.error("Remarks is required")
        } else {
            setLoading(true)
            const response = await Handler({ method: "patch", url: `/booking/details/cancel/${cancel?.booking}`, data: { remarks: cancel?.remarks } })
            if (response?.success) {
                toast.success(response?.message)
                showModal(false)
                setTimeout(() => {
                    reloadWindow()
                    setLoading(false)
                }, 1500);
            } else {
                toast.error(response?.message)
                setLoading(false)
            }
        }
    }
    const clearAll = () => {
        setPageNo(1)
        setFilter((prev) => ({
            ...prev,
            count: 10,
            sortBy: "deliveryDetails.delivery",
            sort: true,
            createdBy: "All",
            deliveryBy: "All",
            remarks: "All",
            pickupBy: "All",
            status: "All",
            carId: "All",
            type: "All",
            leadMode: { label: "All", value: "All" },
            leadAttendedBy: { label: "All", value: "All" },
            billingDate: ""
        }))
        setSearch("")
        localStorage.removeItem('filter')
        setCheckDate({})
        setPicheckDate({})
        setCreatedDate({})
        setCancelledDate({})
    }
    const setItem = (name, value) => {
        const existing = localStorage.getItem('filter');
        let oldData = existing ? JSON.parse(existing) : {};
        oldData[name] = value || "";
        localStorage.setItem('filter', JSON.stringify(oldData));
    };
    // Clicking a BookingStats dashboard card lands here. Each card owns one
    // of these date-range states; clicking a card applies its own filter and
    // clears the OTHER cards' filters only (never the unrelated filters like
    // search/type/status dropdown etc). "Clear All Filters" still clears
    // everything, including these.
    const clearQuickDateFilters = (except) => {
        if (except !== 'createdDate') { setCreatedDate({}); setItem('createdDate', ''); }
        if (except !== 'checkDate') { setCheckDate({}); setItem('checkDate', ''); }
        if (except !== 'picheckDate') { setPicheckDate({}); setItem('picheckDate', ''); }
        if (except !== 'cancelledDate') { setCancelledDate({}); setItem('cancelledDate', ''); }
        if (except !== 'ongoing' && filter?.status === "Ongoing") {
            setFilter((prev) => ({ ...prev, status: "All" }));
            setItem('status', "All");
        }
    };
    const applyQuickFilter = (type) => {
        const today = [new Date(), new Date()];
        switch (type) {
            case "newToday":
                clearQuickDateFilters('createdDate');
                setCreatedDate(today);
                setItem('createdDate', today);
                break;
            case "deliveriesToday":
                clearQuickDateFilters('checkDate');
                setCheckDate(today);
                setItem('checkDate', today);
                break;
            case "pickupsToday":
            case "collectionToday":
                clearQuickDateFilters('picheckDate');
                setPicheckDate(today);
                setItem('picheckDate', today);
                break;
            case "cancelledToday":
                clearQuickDateFilters('cancelledDate');
                setCancelledDate(today);
                setItem('cancelledDate', today);
                break;
            case "ongoing":
                clearQuickDateFilters('ongoing');
                setFilter((prev) => ({ ...prev, status: "Ongoing" }));
                setItem('status', "Ongoing");
                break;
            case "totalBookings":
                clearAll();
                break;
            default:
                break;
        }
        setPageNo(1);
    };
    const getCarDetails = async () => {
        const response = await Handler({ method: 'get', url: `/car/list` })
        if (response?.success) {
            setCarDetails(response?.data)
        } else {
            setCarDetails([])
        }
    }
    const checkDelivery = async (booking) => {
        const date = new Date(new Date(booking?.deliveryDetails?.delivery)?.setHours(0, 0, 0))
        const today = new Date()
        if (today >= date) {
            navigate(`/booking/delivery/${booking?.bookingId}`)
        } else {
            toast.error("Delivery can't be made")
        }
    }
    useEffect(() => {
        getBookingDetails()
    }, [pageNo, filter, checkDate, picheckDate, createdDate, cancelledDate, appliedSearch])
    useEffect(() => {
        getCarDetails()
        dispatch(clearValue())
    }, [])
    useEffect(() => {
        if (userDetails?.id || userDetails?.adminId) {
            getLeadList()
        }
    }, [userDetails])
    return (
        <React.Fragment>
            <h5 className="text-center text-theme fs-4">Booking List</h5>
            <BookingStats onQuickFilter={applyQuickFilter} />
            <div className="layout-card mt-4">
                <div className="row justify-content-between align-items-center">
                    <div className="col-lg-4 d-flex gap-3 align-items-center">
                        <div className="input-group mb-3">
                            <input type="text" className="form-control search-input" autoComplete="off" placeholder="Search..." value={search} onKeyDown={handleKeyDown} onChange={(e) => { if (e.target.value) setSearch(e.target.value); else { setSearch(""); setAppliedSearch(""); setItem('search', ""); setPageNo(1); } }} name="search" />
                            <span className="input-group-text cancel-icon">{search ? <i className="fa-solid fa-circle-xmark cursor-pointer text-theme" onClick={() => { setSearch(""); setItem('search', ""); setAppliedSearch(""); setPageNo(1); }}></i> : ""}</span>
                        </div>
                        <button className="btn btn-sm btn-theme" onClick={handleSearch} disabled={loading}>Search</button>
                    </div>
                    <div className="col-lg-4 d-flex align-items-center justify-content-end">
                        <button className="btn-theme btn" onClick={() => navigate(`/booking/register`)}>Register</button>
                        {person === "admin" ? (loading ? <i className="fa-solid fa-spinner fa-spin ms-2"></i> : <i className="fa-solid fa-download ms-3 fs-5 mb-0 cursor-pointer" onClick={exportToExcel}></i>) : ""}
                    </div>
                </div>
                <div className="row justify-content-end mt-3 align-items-center">
                    <div className="col-xl-8 col-md-6 d-flex gap-2 align-items-center">
                        <div>Total Booking: {total}</div>
                        <button className="btn btn-theme btn-sm" onClick={clearAll}>Clear All Filters</button>
                    </div>
                    <div className="col-xl-2 col-md-3 mt-md-0 mt-3">
                        <Select
                            onChange={(selectedoption) => {
                                setFilter((prev) => ({ ...prev, leadMode: selectedoption }))
                                setPageNo(1);
                                setItem("leadMode", selectedoption)
                            }}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            value={filter?.leadMode || ""}
                            options={[{ label: "All", value: "All" }, { label: "DC", value: "DC" }, { label: "LC", value: "LC" }, { label: "EC", value: "EC" },
                            { label: "Walkin", value: "Walkin" },
                            { label: "Whatsapp", value: "Whatsapp" },
                            { label: "Other", value: "Other" }]}
                            placeholder="Lead Mode"
                        />
                    </div>
                    <div className="col-xl-2 col-md-3 mt-md-0 mt-3">
                        <Select
                            onChange={(selectedoption) => {
                                setFilter((prev) => ({ ...prev, leadAttendedBy: selectedoption }))
                                setPageNo(1)
                                setItem("leadAttendedBy", selectedoption)
                            }}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            value={filter?.leadAttendedBy || ""}
                            options={leadList}
                            placeholder="Lead By"
                        />
                    </div>

                </div>
                <div className='overflow list-table mt-3'>
                    <table className="table-bg table" borderless="true">
                        <thead>
                            <tr className="border-bottom" >
                                <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "bookingId" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("bookingId", false)} >▲</i><i className={filter?.sortBy === "bookingId" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("bookingId", true)} >▼</i></div> Id</div></th>
                                <th className="sticky-cust">Cust</th>
                                <th>
                                    <DropdownToggle label={
                                        <>
                                            Car ID <i className="fa-solid fa-caret-down"></i>
                                        </>
                                    }>
                                        <DropdownButton label="All" className={`${filter?.carId === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("carId", "All") }} />
                                        {
                                            carDetails?.length ?
                                                carDetails?.map((element, i) => {
                                                    return (
                                                        <DropdownButton key={i} label={element?.carId} className={`${filter?.carId === element?.id ? "active-option" : ""} text-uppercase`} onClick={() => { setFilteration("carId", element?.id) }} />
                                                    )
                                                })
                                                : ""
                                        }
                                    </DropdownToggle>
                                </th>
                                <th className="text-center">
                                    <DropdownToggle label={
                                        <>
                                            Status <i className="fa-solid fa-caret-down"></i>
                                        </>
                                    }>
                                        <DropdownButton label="All" className={`${filter?.status === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "All") }} />
                                        <DropdownButton label="Initiated" className={`${filter?.status === "Initiated" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Initiated") }} />
                                        <DropdownButton label="Booked" className={`${filter?.status === "Booked" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Booked") }} />
                                        <DropdownButton label="Cancelled" className={`${filter?.status === "Cancelled" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Cancelled") }} />
                                        <DropdownButton label="Ongoing" className={`${filter?.status === "Ongoing" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Ongoing") }} />
                                        <DropdownButton label="Pending" className={`${filter?.status === "Pending" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Pending") }} />
                                        <DropdownButton label="Completed" className={`${filter?.status === "Completed" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Completed") }} />
                                        <DropdownButton label="Verified" className={`${filter?.status === "Verified" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Verified") }} />
                                        <DropdownButton label="Correction" className={`${filter?.status === "Correction" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Correction") }} />
                                    </DropdownToggle>
                                </th>
                                <th> Action </th>
                                <th> <div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "deliveryDetails.delivery" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("deliveryDetails.delivery", false)} >▲</i><i className={filter?.sortBy === "deliveryDetails.delivery" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("deliveryDetails.delivery", true)} >▼</i></div> <button className='created-at' onClick={() => { handleOpen() }}> DL <i className="fa-solid fa-caret-down"></i> </button>  </div>  </th>
                                <th> <div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "pickupDetails.pickup" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("pickupDetails.pickup", false)} >▲</i><i className={filter?.sortBy === "pickupDetails.pickup" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("pickupDetails.pickup", true)} >▼</i></div> <button className='created-at' onClick={() => { handleOpen1() }}> PK <i className="fa-solid fa-caret-down"></i> </button>  </div>  </th>
                                <th>
                                    <DropdownToggle label={<> Delivery By <i className="fa-solid fa-caret-down"></i> </>}>
                                        <DropdownButton label="All" className={`${filter?.deliveryBy === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("deliveryBy", "All") }} />
                                        {
                                            leadList?.length ?
                                                leadList?.filter(element => element?.label !== "All")?.map((element, i) => {
                                                    return (
                                                        <DropdownButton key={i} label={element?.label} className={`${filter?.deliveryBy === element?.value ? "active-option" : ""} text-uppercase`} onClick={() => { setFilteration("deliveryBy", element?.value) }} />
                                                    )
                                                })
                                                : ""
                                        }
                                    </DropdownToggle>
                                </th>
                                <th>
                                    <DropdownToggle label={<> Pickup By <i className="fa-solid fa-caret-down"></i> </>}>
                                        <DropdownButton label="All" className={`${filter?.pickupBy === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("pickupBy", "All") }} />
                                        {
                                            leadList?.length ?
                                                leadList?.filter(element => element?.label !== "All")?.map((element, i) => {
                                                    return (
                                                        <DropdownButton key={i} label={element?.label} className={`${filter?.pickupBy === element?.value ? "active-option" : ""} text-uppercase`} onClick={() => { setFilteration("pickupBy", element?.value) }} />
                                                    )
                                                })
                                                : ""
                                        }
                                    </DropdownToggle>
                                </th>
                                <th>
                                    <DropdownToggle label=
                                        {<>
                                            Remarks <i className="fa-solid fa-caret-down"></i>
                                        </>}>
                                        <DropdownButton label="All" className={`${filter?.remarks === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("remarks", "All") }} />
                                        <DropdownButton label="Good" className={`${filter?.remarks === "Good" ? "active-option" : ""}`} onClick={() => { setFilteration("remarks", "Good") }} />
                                        <DropdownButton label="Bad" className={`${filter?.remarks === "Bad" ? "active-option" : ""}`} onClick={() => { setFilteration("remarks", "Bad") }} />
                                    </DropdownToggle>
                                </th>

                            </tr>
                        </thead>
                        <tbody>
                            {!loading ?
                                (bookingDetails && bookingDetails?.length !== 0 ? bookingDetails?.map((value, key) => {
                                    return (
                                        <tr key={key} className={`table-content-row ${value?.expired || value?.status === "Pending" || value?.status === "Cancelled" || (value?.carStatus === false && value?.status !== "Completed") || (value?.excessCharges?.length && value?.excessCharges?.filter(element => element?.name === "damage")?.length && Number(value?.excessCharges?.filter(element => element?.name === "damage")[0]?.amount) > 0) || (value?.pendingPhoto?.length > 0) ? "text-red" : ""}    ${value?.custStatus === false ? "text-grey" : ""}`}>
                                            <td>
                                                <div className="d-flex flex-column">
                                                    <a className="" href={`/booking/view/${value?.bookingId}`}>{value?.verified ? <i className="fa-solid fa-circle-check text-success"></i> : ""} {value?.bookingId}</a>
                                                    <small className="reason"> {
                                                        value?.expired
                                                            ? "DL Expired"
                                                            : (value?.carStatus === false && value?.status !== "Completed")
                                                                ? "Car Deactive"
                                                                : (value?.excessCharges?.length && value?.excessCharges?.filter(element => element?.name === "damage")?.length && Number(value?.excessCharges?.filter(element => element?.name === "damage")[0]?.amount) > 0)
                                                                    ? "Excess Charged"
                                                                    : value?.pendingPhoto?.length > 0
                                                                        ? "Booking Pending"
                                                                        : value?.status === "Pending"
                                                                            ? "Pending"
                                                                            : value?.status === "Cancelled"
                                                                                ? "Cancelled"
                                                                                : ""
                                                    }
                                                    </small>
                                                    <small>{value?.custStatus === false ? "Customer Deactive" : ""}</small>
                                                </div>
                                            </td>
                                            <td className="sticky-cust">
                                                <i className="fa-solid fa-circle-info cursor-pointer me-1" onClick={() => { handleToggle(value) }}></i>
                                                <a href={`/customer/view/${value?.customerId}`}> {value?.customerId}</a> <span>{value?.customerStatus === "Verified" ? <i className="fa-solid fa-check-circle text-success"></i> : (value?.customerStatus === "Unverified" ? <i className="fa-solid fa-circle-xmark text-danger"></i> : "")}</span>
                                                <div className="text-capitalize">{(value?.firstName || "") + " " + (value?.lastName || "")}</div>
                                            </td>
                                            <td>{value?.carId}</td>
                                            <td className={`${value?.status === "Completed" ? "text-green" : value?.status === "Ongoing" ? "text-yellow" : value === "Pending" ? "text-red" : ""} fw-bold text-center`}>
                                                <div className="d-flex flex-column align-items-center">
                                                    <span>{value?.status || "Initiated"}</span>
                                                    {value?.verified ? <span className="verified-text">Verified</span> : ""}
                                                    {value?.pendingPhoto?.length && value?.status === "Completed" ? <span className="verified-text">Pending & Closed</span> : ""}
                                                    {!value?.verified && value?.correction?.correction ? <span className="verified-text">Correction</span> : ""}
                                                </div>
                                            </td>
                                            <td>
                                                {
                                                    value?.bookingId ?
                                                        value?.status === "Cancelled" ? "-" :
                                                            value?.status === "Completed" ? <Link to={`/booking/invoice/${value?.bookingId}`} > Generate Bill </Link> :
                                                                <>
                                                                    <DropdownToggle label={"Action"} className="dropdown-list-head">
                                                                        {
                                                                            value?.status === "Ongoing" || value?.status === "Pending" ?
                                                                                <DropdownButton onClick={() => navigate(`/booking/close/${value?.bookingId}`)} className="list-btns list-success-btn" label="Pickup" />
                                                                                : (value?.status === "Booked" && value?.carStatus) ?
                                                                                    <DropdownButton className="list-btns list-success-btn" label="Delivery" onClick={() => { checkDelivery(value) }} /> :
                                                                                    !value?.status ? <DropdownButton className="list-btns list-success-btn" label="Book" onClick={() => navigate(`/booking/update/${value?.bookingId}`)} /> : ""
                                                                        }
                                                                        {
                                                                            (value?.status === "Booked" || !value?.status) ?
                                                                                <DropdownButton label="Cancel" className="list-btns list-danger-btn" onClick={() => { setCancel({ booking: value?.bookingId, remarks: "" }); showModal(true) }} />
                                                                                : value?.status === "Ongoing" ?
                                                                                    <DropdownButton label="Pending" className="list-btns list-danger-btn" onClick={() => navigate(`/booking/pending/${value?.bookingId}`)} />
                                                                                    : ""
                                                                        }
                                                                        {
                                                                            (value?.status === "Booked") ?
                                                                                <DropdownButton label="Edit" className="list-btns list-warning-btn" onClick={() => navigate(`/booking/update/${value?.bookingId}`)} />
                                                                                : value?.status === "Ongoing" ?
                                                                                    <DropdownButton label="Edit" className="list-btns list-warning-btn" onClick={() => navigate(`/booking/delivery/${value?.bookingId}`)} />
                                                                                    : ""
                                                                        }
                                                                    </DropdownToggle>
                                                                </>
                                                        : <button className="btn btn-success btn-sm" onClick={() => navigate(`/booking/register`)}>Create Booking</button>
                                                }
                                            </td>
                                            <td>{value?.deliveryDetails?.delivery ? moment(new Date(value?.deliveryDetails?.delivery)).format("DD/MM/YYYY hh:mm A") : ""}
                                                <div className="text-uppercase">{value?.deliveryDetails?.location || ""}</div>
                                            </td>
                                            <td>{value?.pickupDetails?.pickup ? moment(new Date(value?.pickupDetails?.pickup)).format("DD/MM/YYYY hh:mm A") : ""}
                                                <div className="text-uppercase">{value?.pickupDetails?.location || ""}</div>
                                            </td>
                                            <td className="text-capitalize">{value?.stageHistory?.length ? value?.stageHistory?.filter(element => element?.stage === "Ongoing")?.length ? value?.stageHistory?.filter(element => element?.stage === "Ongoing")[0]?.staffName : "-" : "-"}</td>
                                            <td className="text-capitalize">{value?.stageHistory?.length ? value?.stageHistory?.filter(element => element?.stage === "Completed")?.length ? value?.stageHistory?.filter(element => element?.stage === "Completed")[0]?.staffName : "-" : "-"}</td>
                                            <td>{value?.remarks || "-"}</td>
                                        </tr>
                                    )
                                }) :
                                    <tr className='text-center' ><td colSpan={10}>No Data Found</td></tr>)
                                : <TablePlaceHolder count={10} />
                            }
                        </tbody>
                    </table>
                </div>
                <div className="d-flex align-items-center justify-content-end mt-3">
                    <span className="me-2 fw-medium"> Page Count:  </span>
                    <Select
                        className="inside-select"
                        isDisabled={loading}
                        onChange={(selectedoption) => {
                            setFilteration("count", Number(selectedoption?.value))
                        }}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        value={filter?.count ? { label: filter?.count, value: filter?.count } : { label: 10, value: 10 }}
                        options={[
                            { label: 10, value: 10 },
                            { label: 20, value: 20 },
                            { label: 30, value: 30 },
                            { label: 40, value: 40 },
                            { label: 50, value: 50 },
                        ]}
                        placeholder="PageNo"
                    />
                </div>
                <PageChanger previousValue={Number(pageNo) > 1} nextValue={next} current={Number(pageNo)} onPageChange={setPageNo} pageValue='booking' />
            </div>
            <DatePicker
                ref={calendarRef}
                range
                className='rmdp-mobile'
                inputClass='d-none'
                onChange={(e) => { if (!isNaN(new Date(e[0]))) { setCheckDate([new Date(e[0]), e?.length > 1 ? new Date(e[1]) : new Date(e[0])]); setItem('checkDate', [new Date(e[0]), e?.length > 1 ? new Date(e[1]) : new Date(e[0])]) }; setPageNo(1) }}
                value={checkDate}
                mobileButtons={[
                    {
                        label: "RESET",
                        type: "button",
                        className: "rmdp-button rmdp-action-button",
                        onClick: () => { setCheckDate(); setItem('checkDate', '') },

                    },
                ]}
            />
            <DatePicker
                ref={calendarRef1}
                range
                className='rmdp-mobile'
                inputClass='d-none'
                onChange={(e) => { if (!isNaN(new Date(e[0]))) { setPicheckDate([new Date(e[0]), e?.length > 1 ? new Date(e[1]) : new Date(e[0])]); setItem('picheckDate', [new Date(e[0]), e?.length > 1 ? new Date(e[1]) : new Date(e[0])]) }; setPageNo(1); }}
                value={picheckDate}
                mobileButtons={[
                    {
                        label: "RESET",
                        type: "button",
                        className: "rmdp-button rmdp-action-button",
                        onClick: () => { setPicheckDate(); setItem('picheckDate', '') },
                    },
                ]}
            />
            <Modal header={element?.bookingId} onShow={info} toggle={() => setInfo(false)} overlayToggle={() => setInfo(false)}>
                <div className="text-center fw-medium fs-5">Customer</div>
                <table className="table-bg table" borderless="true">
                    <thead>
                        <tr className="text-center">
                            <th> S.No </th>
                            <th> Proof </th>
                            <th> Status </th>
                            <th> Photo </th>
                            <th> Go </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="align-middle text-center">
                            <td> 1 </td>
                            <td> Mobile </td>
                            <td> {(element?.custType === "local" ? (element?.phone?.length ? element?.phone?.filter((phone) => phone?.status)?.length >= 3 : false) : (element?.phone?.length ? element?.phone?.filter((phone) => phone?.status)?.length >= 2 : false)) ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : "Unverified"} </td>
                            <td> - </td>
                            <td> {(element?.custType === "local" ? (element?.phone?.length ? element?.phone?.filter((phone) => phone?.status)?.length >= 3 : false) : (element?.phone?.length ? element?.phone?.filter((phone) => phone?.status)?.length >= 2 : false)) ? "" : <button onClick={() => { navigate(`/customer/edit/${element?.customerId}/1`) }} className="btn btn-sm btn-success py-1 px-2"> Verify </button>} </td>
                        </tr>
                        <tr className="align-middle text-center">
                            <td> 2 </td>
                            <td> Address </td>
                            <td> {element?.tempAddress?.line1 ? "Uploaded" : "Pending"} </td>
                            <td> - </td>
                            <td> {element?.tempAddress?.line1 ? "" : <button onClick={() => { navigate(`/customer/edit/${element?.customerId}/2`) }} className="btn btn-sm btn-success py-1 px-2"> Upload </button>} </td>
                        </tr>
                        <tr className="align-middle text-center">
                            <td> 3 </td>
                            <td> Photo</td>
                            <td> {element?.photo ? "Uploaded" : "Pending"} </td>
                            <td> - </td>
                            <td>{element?.photo ? "" : <button onClick={() => { navigate(`/customer/edit/${element?.customerId}/8`) }} className="btn btn-sm btn-success py-1 px-2"> Upload </button>} </td>
                        </tr>
                        <tr className="align-middle text-center">
                            <td> 4 </td>
                            <td> DL </td>
                            <td className="">
                                <div>{(element?.kyc?.length ? element?.kyc?.filter(element => element?.type === "dl")?.length ? (element?.kyc?.find(element => element?.type === "dl")?.status) : false : false) ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : "Unverified"}</div>
                                <div>{element?.kyc?.length && element?.kyc?.filter(element => element.type === "dl")?.length ? (element?.kyc?.find(element => element.type === "dl")?.detail?.doe || element?.kyc?.find(element => element.type === "dl")?.detail?.validTo || "") : ""}</div>
                            </td>
                            <td> {(element?.kyc?.length ? element?.kyc?.filter(element => element?.type === "dl")?.length ? (element?.kyc?.filter(element => element?.type === "dl")[0]?.photo?.length >= 2) : false : false) ? "Uploaded" : "Pending"} </td>
                            <td> {(element?.kyc?.length ? element?.kyc?.filter(element => element?.type === "dl")?.length ? (element?.kyc?.filter(element => element?.type === "dl")[0]?.status) : false : false) ? "" : <button onClick={() => { navigate(`/customer/edit/${element?.customerId}/3`) }} className="btn btn-sm btn-success py-1 px-2"> Verify </button>} </td>
                        </tr>
                        <tr className="align-middle text-center">
                            <td> 5 </td>
                            <td> Aadhar </td>
                            <td> {(element?.kyc?.length ? element?.kyc?.filter(element => element?.type === "aadhaar")?.length ? (element?.kyc?.filter(element => element?.type === "aadhaar")[0]?.status) : false : false) ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : "Unverified"} </td>
                            <td> {(element?.kyc?.length ? element?.kyc?.filter(element => element?.type === "aadhaar")?.length ? (element?.kyc?.filter(element => element?.type === "aadhaar")[0]?.photo?.length >= 2) : false : false) ? "Uploaded" : "Pending"} </td>
                            <td> {(element?.kyc?.length ? element?.kyc?.filter(element => element?.type === "aadhaar")?.length ? (element?.kyc?.filter(element => element?.type === "aadhaar")[0]?.status) : false : false) ? "" : <button onClick={() => { navigate(`/customer/edit/${element?.customerId}/4`) }} className="btn btn-sm btn-success py-1 px-2"> Verify </button>} </td>
                        </tr>
                        <tr className="align-middle text-center">
                            <td> 6 </td>
                            <td> Passport </td>
                            <td className="">
                                <div>{(element?.kyc?.length ? element?.kyc?.filter(element => element?.type === "passport")?.length ? (element?.kyc?.find(element => element?.type === "passport")?.status) : false : false) ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : "Unverified"}</div>
                                <div>{element?.kyc?.length && element?.kyc?.filter(element => element?.type === "passport")?.length ? (element?.kyc?.find(element => element?.type === "passport")?.detail?.passportDate || element?.kyc?.find(element => element?.type === "passport")?.detail?.validUpto || "") : ""}</div>
                            </td>
                            <td> {(element?.kyc?.length ? element?.kyc?.filter(element => element?.type === "passport")?.length ? (element?.kyc?.filter(element => element?.type === "passport")[0]?.photo?.length >= 3) : false : false) ? "Uploaded" : "Pending"} </td>
                            <td>{(element?.kyc?.length ? element?.kyc?.filter(element => element?.type === "passport")?.length ? (element?.kyc?.filter(element => element?.type === "passport")[0]?.status) : false : false) ? "" : <button onClick={() => { navigate(`/customer/edit/${element?.customerId}/5`) }} className="btn btn-sm btn-success py-1 px-2"> Verify </button>} </td>
                        </tr>
                        {
                            element?.email ?
                                <tr className="align-middle text-center">
                                    <td> 7 </td>
                                    <td> Email</td>
                                    <td> {element?.email?.emailId ? "Uploaded" : "Pending"} </td>
                                    <td> {element?.email?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : "Unverified"} </td>
                                    <td>{element?.email?.status ? "" : <button onClick={() => { navigate(`/customer/edit/${element?.customerId}/1`) }} className="btn btn-sm btn-success py-1 px-2"> Upload </button>} </td>
                                </tr>
                                : ""
                        }

                    </tbody>
                </table>
                {
                    element?.secPhoto || (element?.otherKyc?.length ? element?.otherKyc?.filter(element => element?.type === "dl")?.length ? (element?.otherKyc?.filter(element => element?.type === "dl")[0]?.photo?.length >= 2) : false : false) || (element?.otherKyc?.length ? element?.otherKyc?.filter(element => element?.type === "aadhaar")?.length ? (element?.otherKyc?.filter(element => element?.type === "aadhaar")[0]?.photo?.length >= 2) : false : false) || (element?.otherKyc?.length ? element?.otherKyc?.filter(element => element?.type === "passport")?.length ? (element?.otherKyc?.filter(element => element?.type === "passport")[0]?.photo?.length >= 3) : false : false)
                        ?
                        <>
                            <div className="text-center fw-medium fs-5">Co-Passenger</div>
                            <table className="table-bg table" borderless="true">
                                <thead>
                                    <tr className=" text-center">
                                        <th> S.No </th>
                                        <th> Proof </th>
                                        <th> Status </th>
                                        <th> Photo </th>
                                        <th> Go </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="align-middle text-center">
                                        <td> 1 </td>
                                        <td> Photo </td>
                                        <td> {element?.secPhoto ? "Uploaded" : "Pending"} </td>
                                        <td> - </td>
                                        <td>{element?.secPhoto ? "" : <button onClick={() => { navigate(`/customer/edit/${element?.customerId}/6`) }} className="btn btn-sm btn-success py-1 px-2"> Upload </button>} </td>
                                    </tr>
                                    <tr className="align-middle text-center">
                                        <td> 2 </td>
                                        <td> DL </td>
                                        <td>
                                            <div>{(element?.otherKyc?.length ? element?.otherKyc?.filter(element => element?.type === "dl")?.length ? (element?.otherKyc?.filter(element => element?.type === "dl")[0]?.status) : false : false) ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : "Unverified"} </div>
                                            <div>{(element?.otherKyc?.length && element?.otherKyc?.filter(element => element?.type === "dl")?.length ? (element?.find?.filter(element => element?.type === "dl")?.detail?.validTo || "") : false)} </div>
                                        </td>
                                        <td> {(element?.otherKyc?.length ? element?.otherKyc?.filter(element => element?.type === "dl")?.length ? (element?.otherKyc?.filter(element => element?.type === "dl")[0]?.photo?.length >= 2) : false : false) ? "Uploaded" : "Pending"} </td>
                                        <td> {(element?.otherKyc?.length ? element?.otherKyc?.filter(element => element?.type === "dl")?.length ? (element?.otherKyc?.filter(element => element?.type === "dl")[0]?.status) : false : false) ? "" : <button onClick={() => { navigate(`/customer/edit/${element?.customerId}/6`) }} className="btn btn-sm btn-success py-1 px-2"> Verify </button>} </td>
                                    </tr>
                                    <tr className="align-middle text-center">
                                        <td> 3 </td>
                                        <td> Aadhar </td>
                                        <td> {(element?.otherKyc?.length ? element?.otherKyc?.filter(element => element?.type === "aadhaar")?.length ? (element?.otherKyc?.filter(element => element?.type === "aadhaar")[0]?.status) : false : false) ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : "Unverified"} </td>
                                        <td> {(element?.otherKyc?.length ? element?.otherKyc?.filter(element => element?.type === "aadhaar")?.length ? (element?.otherKyc?.filter(element => element?.type === "aadhaar")[0]?.photo?.length >= 2) : false : false) ? "Uploaded" : "Pending"} </td>
                                        <td> {(element?.otherKyc?.length ? element?.otherKyc?.filter(element => element?.type === "aadhaar")?.length ? (element?.otherKyc?.filter(element => element?.type === "aadhaar")[0]?.status) : false : false) ? "" : <button onClick={() => { navigate(`/customer/edit/${element?.customerId}/6`) }} className="btn btn-sm btn-success py-1 px-2"> Verify </button>} </td>
                                    </tr>
                                    <tr className="align-middle text-center">
                                        <td> 4 </td>
                                        <td> Passport </td>
                                        <td>
                                            <div> {(element?.otherKyc?.length ? element?.otherKyc?.filter(element => element?.type === "passport")?.length ? (element?.otherKyc?.filter(element => element?.type === "passport")[0]?.status) : false : false) ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : "Unverified"} </div>
                                            <div> {(element?.otherKyc?.length && element?.otherKyc?.filter(element => element?.type === "passport")?.length ? (element?.otherKyc?.find(element => element?.type === "passport")?.detail?.passportDate || element?.otherKyc?.find(element => element?.type === "passport")?.detail?.validUpto || "") : "")} </div>
                                        </td>
                                        <td> {(element?.otherKyc?.length ? element?.otherKyc?.filter(element => element?.type === "passport")?.length ? (element?.otherKyc?.filter(element => element?.type === "passport")[0]?.photo?.length >= 3) : false : false) ? "Uploaded" : "Pending"} </td>
                                        <td>{(element?.otherKyc?.length ? element?.otherKyc?.filter(element => element?.type === "passport")?.length ? (element?.otherKyc?.filter(element => element?.type === "passport")[0]?.status) : false : false) ? "" : <button onClick={() => { navigate(`/customer/edit/${element?.customerId}/6`) }} className="btn btn-sm btn-success py-1 px-2"> Verify </button>} </td>
                                    </tr>
                                </tbody>
                            </table>
                        </>
                        : ""
                }


            </Modal>
            <Modal header={"Cancel Booking"} onShow={modal} toggle={() => showModal(false)} overlayToggle={() => showModal(false)}>
                Do you really wanna cancel the booking : {cancel?.booking}?
                <input placeholder="Remarks" autoComplete="off" className="form-control input-theme text-uppercase mt-3" onChange={(e) => setCancel((prev) => ({ ...prev, remarks: e.target.value }))} />
                <div className="pt-4 pb-2 text-center">
                    <button disabled={loading} className="btn btn-sm btn-danger" onClick={cancelBooking}>Cancel Booking</button>
                </div>
            </Modal>
            <Modal header={"Download Booking"} onShow={downloadModal} toggle={() => setDownloadModal(false)} overlayToggle={() => setDownloadModal(false)}>
                <Select
                    className="inside-select"
                    isDisabled={loading}
                    onChange={(selectedoption) => {
                        setStatus(selectedoption)
                    }}
                    styles={{
                        control: (base, state) => ({
                            ...base,
                            borderColor: state.isFocused ? "#f16436" : base.borderColor,
                            boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                            "&:hover": {
                                borderColor: "#f16436"
                            }
                        }),
                        option: (style, state) => ({
                            ...style,
                            backgroundColor: state.isSelected
                                ? "#f16436"
                                : (state.isFocused || state.isActive)
                                    ? "#f164361a"
                                    : "white",
                            color: state.isSelected ? "white" : "black"
                        })
                    }}
                    value={status || ""}
                    options={[{ label: "All", value: "All" },
                    { label: "Booked", value: "Booked" },
                    { label: "Ongoing", value: "Ongoing" },
                    { label: "Pending", value: "Pending" },
                    { label: "Cancelled", value: "Cancelled" },
                    { label: "Completed", value: "Completed" },
                    { label: "Verified", value: "Verified" }]}
                    placeholder="Status"
                />
                <div className="d-flex align-items-center justify-content-center flex-column gap-4 mt-4">
                    {/* {billingDate ? <input className="form-control input-theme text-uppercase" readOnly value={billingDate ? moment(new Date(billingDate)).format("MM/YYYY") : ""} /> : ""} */}
                    <Calendar onlyMonthPicker disabled={loading} value={billingDate || ""} onChange={(e) => { setBillingDate(new Date(e)) }} />
                </div>
                <div className="pt-4 pb-2 text-center">
                    <button className="btn btn-sm btn-danger" disabled={loading} onClick={exportToExcel}>Export Booking</button>
                </div>
            </Modal>
        </React.Fragment>
    )
}

export default List;